import Component from 'Spackle/Components/Component';

export default class UserProfileComponent extends Component {
    params() {
        return {
            accountId: $('#accountId').val(),
            authenticatedUserId: $('#authenticatedUserId').val(),
            authenticatedUserKey: $('#authenticatedUserKey').val()
        };
    }

    load(containerId) {
        this.bindEditClick(containerId);

        var data = {
            url: this.data(),
            params: this.params()
        };

        this.loader.load(containerId, this.templateId(), data, this.process()).then(function () {
            // open the edit modal if the loaded container is specified in the window hash
            if (containerId === window.location.hash) {
                // need to remove hash or this will retrigger
                window.location.hash = '';

                $(containerId).find('.edit4').click();
            }
        });
    }

    // the Form type Component to be used to render in the modal on Edit click
    form() {
    }

    modalContainer() {
        return '#userProfileModal .modal-content';
    }

    loadModal(containerId) {
        this.form().load(this.modalContainer(), containerId);
    }

    bindEditClick(containerId) {
        var container = $(containerId);
        container.on('load.rendered', $.proxy(function () {
            container.find('a.edit4').unbind('click').click($.proxy(function () {
                this.loadModal(containerId);
                return false;
            }, this));
        }, this));

        var event = 'form.saved'+containerId;
        $(this.modalContainer()).unbind(event).on(event, $.proxy(function () {
            return this.load(containerId);
        }, this));

        // listen for modal close event so we can clear the modal content
        $(document).unbind('hidden.bs.modal').on('hidden.bs.modal', $(this.modalContainer()).parent(), $.proxy(function () {
            $(this.modalContainer()).html('');
        }, this));
    }
}
